import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {FlightService} from "app/services";
import {filterFlights} from "./filter-flights.slice";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {getApiErrorMessage} from "app/utils/getApiErrorMessage";
import store from "../../../../store";

interface UpdateFlightStateParams {
  id: string;
  body: any;
  onSuccess?: Function;
  onError?: Function;
  shouldRefetch?: boolean;
}

export const updateFlight = (params: UpdateFlightStateParams) => async (dispatch: Dispatch) => {
  const filters = store.getState().flights.flightsList.filterFlights;
  try {
    dispatch(setLoading(true));
    const { shouldRefetch = true } = params;
    const {
      id,
      sectorPrices,
      aircraftDefinitionId,
      ...others
    } = params.body as any;

    const formatSectors = sectorPrices.map((item: any) => {
      const {id, prices, ...others} = item;
      const {id: id2, ...others2} = prices;
      return {
        ...others,
        prices: others2
      }
    });

    const formattedBodyStructure = {
      ...others,
      // If aircraftDefinitionId was set but aircraftId is empty, use it
      aircraftId: others.aircraftId || aircraftDefinitionId || "",
      sectorPrices: formatSectors,
    }
    const response = await FlightService.updateFlight(params.id, formattedBodyStructure);

    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Flight changed successfully!' : 'Fluturimi u ndryshua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(""));
      // @ts-ignore
      if (!shouldRefetch) {
        return;
      }
      dispatch(
          // @ts-ignore
          filterFlights({
            ...filters,
            arrivalAirportId: filters.arrivalAirportId,
            departureAirportId: filters.departureAirportId,
            page: filters.page,
          })
      );
    }
  } catch (err: unknown) {
    const message = getApiErrorMessage(err);

    dispatch(errorMsg(message));
    if (params.onError) params.onError();
    dispatch(setError(message));
  } finally {
    dispatch(setLoading(false));
  }
};

interface UpdateFlightSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateFlightSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "flights/update-flight",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
